<template>
  <div>
    <div :class="s.wrap">
      <div :class="s.form_group">
        <label :class="s.label">呼気アルコール測定結果</label>
        <div :class="s.input_group">
          <input
            class="form-control"
            type="number"
            step="0.01"
            min="0"
            max="999.99"
            v-model.number="form.alcohol_level"
            :class="s.input"
          />
          <span :class="s.unit">mg/L</span>
        </div>
      </div>

      <div :class="s.buttons">
        <LargeBtn
          @click="submit"
          :color="'blue'"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? '送信中...' : '送信' }}
        </LargeBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LargeBtn from '../../parts/LargeBtn.vue';

export default {
  name: 'driver-daily-check',
  props: ['data'],
  components: {
    LargeBtn,
  },
  data() {
    return {
      form: {
        alcohol_level: null,
      },
      isSubmitting: false,
    };
  },
  computed: {
    ...mapState(['helper', 'user']),
    userId() {
      return this.data?.user_id || this.user.id;
    },
    today() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** モーダルを閉じる */
    hideModal() {
      this.$store.dispatch('modal/contents/hideModal', null, { root: true });
    },

    /** 送信 */
    async submit() {
      // バリデーション
      if (this.form.alcohol_level === null || this.form.alcohol_level === '') {
        alert('アルコール濃度を入力してください。');
        return;
      }

      if (this.form.alcohol_level < 0 || this.form.alcohol_level > 999.99) {
        alert('アルコール濃度は0～999.99の範囲で入力してください。');
        return;
      }

      this.isSubmitting = true;
      this.showLoading();

      const params = {
        date: this.today,
        user_id: this.userId,
        alcohol_level: this.form.alcohol_level,
      };

      try {
        const response = await this.axios({
          method: 'POST',
          url: '/v1/driverDailyCheck/update',
          data: params,
        });

        const res = response.data;

        if (res.status === 200) {
          // ユーザー情報を再取得してdriverDailyCheckを更新
          await this.$store.dispatch('user/update');
          this.hideModal();
        } else {
          alert('エラーが発生しました。再度お試しください。');
        }
      } catch (error) {
        console.error(error);
        alert('エラーが発生しました。再度お試しください。');
      } finally {
        this.isSubmitting = false;
        this.hideLoading();
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  padding: 20px 15px;
}

.form_group {
  margin-bottom: 15px;
}

.label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

.input_group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.unit {
  color: #666;
  white-space: nowrap;
}
</style>
